// headers.ts
import { getEnvVariable } from "../../../../envs";
import { getApplicationToken } from "../../Utils/auth";
/**
 * Gets user preauth data from localStorage profile
 * @description Dynamically retrieves userId and roleIds from localStorage profile for x-preauth header
 * @returns {object} Object containing username (number from profile.userId) and roles (number array from profile.modulePermissions)
 */
const getUserPreauth = () => {
    const userProfile = localStorage.getItem('profile');
    if (!userProfile || userProfile === 'null') {
        console.warn('No user profile found in localStorage');
        return { username: 0, roles: [] };
    }
    try {
        const user = JSON.parse(userProfile);
        // Extract username from userId in profile
        const username = user.userId !== undefined && user.userId !== null
            ? Number(user.userId)
            : 0;
        // Extract all roleIds from modulePermissions array
        let roles = [];
        if (user?.modulePermissions && Array.isArray(user.modulePermissions)) {
            // Extract all roleIds from modulePermissions
            user.modulePermissions.forEach((entry) => {
                if (entry.roleId !== undefined && entry.roleId !== null) {
                    const roleNum = Number(entry.roleId);
                    if (!isNaN(roleNum)) {
                        roles.push(roleNum);
                    }
                }
            });
            console.log(`x-preauth loaded from profile: username=${username}, roles=[${roles.join(',')}]`);
        }
        else if (user?.roles && Array.isArray(user.roles)) {
            // Fallback to roles array if modulePermissions not available
            roles = user.roles.map((r) => Number(r)).filter((r) => !isNaN(r));
            console.log(`x-preauth loaded from profile.roles: username=${username}, roles=[${roles.join(',')}]`);
        }
        // Log warning if no roles found in profile
        if (roles.length === 0) {
            console.warn('No roles found in user profile');
        }
        return { username, roles };
    }
    catch (error) {
        console.error('Error parsing user profile for preauth:', error);
        return { username: 0, roles: [] };
    }
};
/**
 * Public, CDN-cacheable endpoints — the static flow *config* (e.g. `PublicFlowBuilder/view`) and the
 * `PublicFlowBuilderRecord/Grid` listings. For these we skip the `Cache-Control: no-cache` request header
 * so the browser/CloudFront cache can serve responses instead of revalidating on every call.
 *
 * Only the single-record `PublicFlowBuilderRecord/get/...` keeps `no-cache` (a stale single record is the
 * risky case); the `Grid` listing is treated as public per request.
 */
const isPublicUrl = (url) => {
    if (typeof url !== 'string')
        return false;
    const u = url.toLowerCase();
    if (!u.includes('public'))
        return false;
    // Single-record fetch stays on no-cache; the Grid listing is cacheable-public.
    if (u.includes('publicflowbuilderrecord') && !u.includes('publicflowbuilderrecord/grid')) {
        return false;
    }
    return true;
};
export const getHeaders = (url) => {
    // Get token dynamically on each call instead of caching at module load
    const token = getApplicationToken() || '';
    const preauth = getUserPreauth();
    const headers = {
        'Content-Type': 'application/json',
        'x-preauth': JSON.stringify(preauth)
    };
    // Only bust the cache on non-public URLs; public endpoints stay cacheable.
    if (!isPublicUrl(url)) {
        headers['Cache-Control'] = 'no-cache';
    }
    if (token) {
        headers['Authorization'] = `${token}`;
    }
    return headers;
};
export const getbasePath = () => {
    return localStorage.getItem('AccessPortal') === 'I' ? getEnvVariable('InternalBasepath') : getEnvVariable('ExternalBasepath');
};
